// extracted by mini-css-extract-plugin
export default {"card-container":"InicioAdmin_card-container__ojivv","cuadro":"InicioAdmin_cuadro__B5Ka8"};